import type {
  OutboundWebhookPayload,
  WebhookDispatchResult,
} from '@/modules/communications/types/webhook.types';

/**
 * Placeholder: no HTTP outbound desde el navegador (secrets en Worker).
 */
export async function dispatchOutboundWebhook(
  payload: OutboundWebhookPayload,
): Promise<WebhookDispatchResult> {
  if (import.meta.env.DEV) {
    console.info('[erp:webhook:placeholder]', {
      event: payload.event,
      id: payload.id,
    });
  }
  return { ok: true, status: 'placeholder', durable: false };
}
